<template>
    <el-button type="danger" size="small" circle>
        <ComTooltip content="Roskakori">
            <el-icon>
                <Delete></Delete>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>
<script lang="ts">
import { defineComponent } from "vue"
import { Delete } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Delete,
        ComTooltip,
    },
})
</script>
